import React from 'react';
import { motion } from 'framer-motion';
import rea1Image from '../assets/logos/rea1.png';
import rea2Image from '../assets/logos/rea2.png';

// Composant fenêtre MacBook
const MacbookWindow = ({ image }) => {
  return (
    <motion.div 
      className="lg:w-1/2 px-4"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      viewport={{ once: true }}
    >
      <motion.div 
        className="mx-auto w-full max-w-xl"
        whileHover={{ 
          scale: 1.05,
          transition: { duration: 0.3 }
        }}
      >
        {/* Barre supérieure MacBook */}
        <div className="bg-gray-800 rounded-t-lg h-8 flex items-center px-3">
          <div className="flex space-x-2">
            <div className="w-3 h-3 rounded-full bg-red-500"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
          </div>
        </div>
        
        {/* Contenu de la fenêtre */}
        <div className="bg-white rounded-b-lg overflow-hidden shadow-xl">
          <img 
            src={image} 
            alt="Réalisation" 
            className="w-full h-auto object-cover"
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

const RealisationsSection = () => {
  return (
    <div className="relative overflow-hidden py-20" id="realisations">
      {/* Section entière en diagonal */}
      <div className="w-full bg-[#0A2540] transform -skew-y-6 py-32 relative overflow-hidden">
        {/* Contenu redressé pour compenser l'inclinaison */}
        <div className="container mx-auto px-4 md:px-8 lg:px-16 transform skew-y-6">
          <div className="text-center mb-16">
            <motion.h2 
              className="text-2xl md:text-3xl lg:text-4xl font-medium mb-6 text-white leading-tight"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              Nos réalisations
            </motion.h2>
            
            <motion.p 
              className="text-gray-300 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Découvrez nos projets récents, fruit d'une collaboration étroite avec nos clients.
            </motion.p>
          </div>
          
          {/* Espace pour les deux réalisations */}
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Première réalisation */}
            <MacbookWindow 
              image={rea1Image}
            />
            
            {/* Deuxième réalisation */}
            <MacbookWindow 
              image={rea2Image}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealisationsSection;
